import { useState } from 'react';
import { GlobalProvider } from './context/GlobalProvider';

import { BMToken } from './portlet/Token';
import ResourceEnvironment from './portlet/ResourceEnvironment';
import Pages from './pages/Pages';

function App() {

    const [env, setEnv] = useState(false);
    const [bmToken, setBMToken] = useState(false);

    return (
        <GlobalProvider>
            <ResourceEnvironment setEnv={setEnv} />
            <BMToken setBMToken={setBMToken} />
            {env && bmToken && <Pages />}
        </GlobalProvider>
    );
}

export default App;